import type { CartAddOn } from '../types/display'

export interface AddOnGroup {
  /** null when the cashier sent no category for these add-ons. */
  categoryTitle: string | null
  addOns: CartAddOn[]
}

/** Groups an item's add-ons under their cashier category, the way the cashier's
 *  own cart shows them ("Ekstra til pizza: Ekstra ost, Ekstra pepperoni").
 *
 *  Order is preserved: groups appear in the order their first add-on arrives,
 *  and add-ons keep their order within a group, so the display matches the
 *  cashier rather than re-sorting alphabetically. Add-ons with no
 *  `categoryTitle` — older cashier builds — collect into a single trailing
 *  group with a null title, which renders as a plain list. */
export function groupAddOns(addOns: CartAddOn[] | undefined): AddOnGroup[] {
  if (!addOns?.length) return []

  const groups: AddOnGroup[] = []
  const byTitle = new Map<string, AddOnGroup>()

  for (const addOn of addOns) {
    const title = addOn.categoryTitle?.trim() ? addOn.categoryTitle : null
    const key = title ?? ' uncategorised'

    const existing = byTitle.get(key)
    if (existing) {
      existing.addOns.push(addOn)
      continue
    }

    const group: AddOnGroup = { categoryTitle: title, addOns: [addOn] }
    byTitle.set(key, group)
    groups.push(group)
  }

  return groups
}
